import React, { useState, useEffect, useContext } from 'react';
import FlowContext from '../../context/FlowContext';
import ConversationFlowBreadCrumbsWithFlowConfig from '../ConversationFlow/ConversationFlowBreadCrumbsWithFlowConfig';
import { KnowledgeBasesList } from './KnowledgeBasesList';

export const KnowledgeBases = (props) => {
    const flowContext = useContext(FlowContext);
  
    useEffect(() => {
        if (flowContext.lastPublication) {
          props.setBreadscrumbs(null);
          props.setBreadscrumbs(
            <ConversationFlowBreadCrumbsWithFlowConfig
              contextBots={flowContext}
            />,
          );
        }
    }, [flowContext.lastPublication]);

    return (
        <div style={{ height: '100%', overflow: 'hidden' }}>
            <KnowledgeBasesList></KnowledgeBasesList>
        </div>
    );
};

export default KnowledgeBases;